import axios from 'axios';
const PowerReviewsApi = (apiKey) => {
  if (!apiKey) return;
  const fetchProductReviews = async (productId) => {
    if (!productId) return;
    try {
      const powerReviewsUrl = `https://readservices-b2c.powerreviews.com/m/4404/l/en_US/product/${productId}/reviews?apikey=${apiKey}`;
      return (await axios.get(powerReviewsUrl)).data;
    } catch (error) {
      console.error(error);
    }
  };
  return {
    fetchProductReviews,
  };
};

export default PowerReviewsApi;
